var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 16.25V14.75C15.0996 13.9544 14.7835 13.1913 14.2209 12.6287C13.6583 12.0661 12.8953 11.75 12.0996 11.75H6.09961C5.30396 11.75 4.5409 12.0661 3.97829 12.6287C3.41568 13.1913 3.09961 13.9544 3.09961 14.75V16.25",
    stroke: "#2C323F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09961 8.75C10.7565 8.75 12.0996 7.40685 12.0996 5.75C12.0996 4.09315 10.7565 2.75 9.09961 2.75C7.44275 2.75 6.09961 4.09315 6.09961 5.75C6.09961 7.40685 7.44275 8.75 9.09961 8.75Z",
    stroke: "#2C323F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonIcon05);
export default __webpack_public_path__ + "static/media/lesson-icon-05.d58cc54a36bfbe088b6dbc6e4f497791.svg";
export { ForwardRef as ReactComponent };